<div #gmap style="width:100%;height:300px; background-color: orange;"></div>
